<template>
    <div class="goods-detail">
        <div class="detail-top">
            <div class="detail-left">
                <!-- 左侧顶部店铺信息 -->
                <div class="shop-author-info">
                    <div class="author-left">
                        <img :src="((detail.shop || {}).logo || (detail.member || {}).avatar) |default_img(false)" alt="" class="author-avatar" />
                        <div class="author-info">
                            <div class="shop-name">{{detail.shop && detail.shop.shop_name ? detail.shop.shop_name : ''}}</div>
                            <div class="author-info-line">
                                <div class="desc">{{(detail.member || {}).job || '-'}}</div>
                                <div class="count">作品数:{{(detail.member || {}).works||0}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="author-right">
                        <div :class="['btn-item',{'shop-collected':detail.is_shop_collect}]" @click="onShopCollect">
                            <img v-if="!detail.is_shop_collect" src="@/assets/images/icon-like.png" alt="" class="btn-icon">
                            {{detail.is_shop_collect ? '已关注' : '关注'}}
                        </div>
                        <div class="btn-item" @click="$router.push({name:'ShopHome',query:{uid:(detail.member || {}).code}})">
                            <img src="@/assets/images/icon-store.png" alt="" class="btn-icon">
                            进店
                        </div>
                    </div>
                </div>
                <!-- 产品图灯箱 -->
                <div class="goods-img-box">
                    <div class="img-list" ref="imgList">
                        <div class="prev" v-show="show_prev_btn" @click="scrollImgList('up')">
                            <Icon type="ios-arrow-up" />
                        </div>
                        <div :class="['img-item',{active:current_img_index == index}]" v-for="(item,index) in image_list" :key="index" @mouseenter="current_img_index = index">
                            <img :src="`${item.raw}${item.type == 'video' ? '?x-oss-process=video/snapshot,t_5000,f_jpg,w_160,h_178,m_fast,ar_auto' :''}`" alt="">
                            <div v-if="item.type === 'video'" class="player-icon">
                                <img src="@/assets/images/icon-mall-player.png" alt="" />
                            </div>
                        </div>
                        <div v-if="image_list.length >= 5" class="next" v-show="show_next_btn" @click="scrollImgList('down')">
                            <Icon type="ios-arrow-down" />
                        </div>
                    </div>
                    <div class="main-img">
                        <img v-if="image_list.length && current_image.type == 'image'" :src="current_image.raw | default_img" alt="">
                        <video v-if="image_list.length && current_image.type != 'image'" :src="current_image.raw" muted autoplay controls="controls"></video>
                    </div>
                </div>
                <!-- 产品详情 -->
                <div class="detail-box">
                    <div :class="['detail-tabs',{'tabs-sticky':true}]">
                        <div :class="['tabs-item',{active:current_tab == 'params'}]" @click="current_tab = 'params'">参数信息</div>
                        <div :class="['tabs-item',{active:current_tab == 'detail'}]" @click="current_tab = 'detail'">商品详情</div>
                        <div :class="['tabs-item',{active:current_tab == 'evaluate'}]" @click="current_tab = 'evaluate'">用户评价</div>
                        <!-- <div :class="['tabs-item',{active:current_tab == 'author'}]" @click="current_tab = 'author'">设计师信息</div> -->
                        <div :class="['tabs-item',{active:current_tab == 'like'}]" @click="current_tab = 'like'">猜你喜欢</div>
                    </div>
                    <div class="detail-wrapper">
                        <div ref="params" class="part-title">参数信息</div>
                        <div class="params-table">
                            <table>
                                <tbody>
                                    <tr v-for="(row, rowIndex) in tableParams" :key="rowIndex">
                                        <td class="label" v-for="(cell, cellIndex) in row" :key="cellIndex" :class="{'value': cellIndex % 2 === 1}">{{ cell }}</td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="label">款式分类</td>
                                        <td class="value">时装类(上衣)</td>
                                        <td class="label">款号</td>
                                        <td class="value">SZ202510141706</td>
                                    </tr>
                                    <tr>
                                        <td class="label">适用性别</td>
                                        <td class="value">女性</td>
                                        <td class="label">适用季节</td>
                                        <td class="value">秋冬</td>
                                    </tr>
                                    <tr>
                                        <td class="label">服装版型</td>
                                        <td class="value">宽松</td>
                                        <td class="label">厚薄</td>
                                        <td class="value">常规</td>
                                    </tr>
                                    <tr>
                                        <td class="label">面料成分</td>
                                        <td class="value">100%羊绒</td>
                                        <td class="label">里料成分</td>
                                        <td class="value">无里材质</td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                        <div ref="detail" class="part-title">商品详情</div>
                        <div class="detail-content" v-html="detail.content"></div>
                        <div class="evaluate-part" ref="evaluate" >
                            <div class="top-part">
                                <div class="top-part-title">用户评价({{comments.length}})</div>
                                <!-- <div class="sort-btn">
                                    最新评价<Icon type="ios-arrow-down" />
                                </div> -->
                            </div>
                            <div class="evaluate-list">
                                <div class="evaluate-item" v-for="(item,index) in comments" :key="index">
                                    <img :src="(item.frommember || {}).avatar|default_img" alt="" class="user-avatar" />
                                    <div class="item-content">
                                        <div class="user-name">{{(item.frommember || {}).nickname || (item.frommember || {}).username}}</div>
                                        <div class="date-spec">
                                            <span>{{item.create_time|date_format('YYYY-MM-DD HH:mm')}}</span><span>{{item.spec_info}}</span>
                                        </div>
                                        <div class="evaluate-content">{{item.content}}</div>
                                        <div class="evaluate-img-list" v-viewer="viewerOptions">
                                            <div class="evaluate-img-item" v-for="(pic,ipic) in item.image_list" :key="ipic">
                                                <img v-if="typeof pic === 'string' && !util.is_video(pic)" :src="pic|default_img" alt="" :data-original="pic" class="cover-img" />
                                                <img v-else-if="typeof pic === 'string' && util.is_video(pic)" :src="`${pic}?x-oss-process=video/snapshot,t_1000,m_fast,ar_auto`" class="cover-img" @click="onPreviewVideo(pic)" style="cursor:pointer;" />
                                                <img v-else-if="pic && pic.raw && !util.is_video(pic.raw_name)" :src="pic.raw|default_img" alt="" :data-original="pic.raw" class="cover-img" />
                                                <img v-else-if="pic && pic.raw && util.is_video(pic.raw_name)" :src="`${pic.raw}?x-oss-process=video/snapshot,t_1000,m_fast,ar_auto`" class="cover-img" @click="onPreviewVideo(pic.raw)" style="cursor:pointer;" />
                                                <img v-if="typeof pic === 'string' && util.is_video(pic)" src="@/assets/images/icon-mall-play.png" alt="" class="video-play" @click="onPreviewVideo(pic)" style="cursor:pointer;" />
                                                <img v-else-if="pic && pic.raw && util.is_video(pic.raw_name)" src="@/assets/images/icon-mall-play.png" alt="" class="video-play" @click="onPreviewVideo(pic.raw)" style="cursor:pointer;" />
                                            </div>
                                        </div>
                                        <div class="comment-like-box">
                                            <div :class="['box-item',{active:item.is_zan}]" @click="onUsefulClick(item,index,'parent','')">
                                                <img v-if="!item.is_zan" src="@/assets/images/icon-mall-goods-detail-useful.png" alt="" class="item-icon">
                                                <img v-else src="@/assets/images/icon-mall-goods-detail-useful-active.png" alt="" class="item-icon">
                                                有用({{item.zan_count || 0}})
                                            </div>
                                            <div :class="['box-item',{active:item.commentting}]" @click="onCommentClick(item,index,'parent','')">
                                                <img v-if="!item.commentting" src="@/assets/images/icon-mall-goods-detail-comment.png" alt="" class="item-icon">
                                                <img v-else src="@/assets/images/icon-mall-goods-detail-comment-active.png" alt="" class="item-icon">
                                                回复({{item.reply_count || 0}})
                                            </div>
                                        </div>
                                        <div class="reply-box" v-if="item.commentting">
                                            <div class="reply-input">
                                                <input placeholder="添加回复" v-model="reply_comment" />
                                            </div>
                                            <div class="reply-btn" @click="onCommentReply">发送</div>
                                        </div>
                                        <div class="child-comment-box" v-if="item.commentting">
                                            <div class="child-comment-item" v-for="(child,ichild) in item.children" :key="ichild">
                                                <img :src="(child.frommember || {}).avatar|default_img" alt="" class="child-comment-avatar" />
                                                <div class="child-comment-content">
                                                    <div class="comment-user-name">
                                                        {{(child.frommember || {}).nickname || (child.tomember || {}).username}}
                                                    </div>
                                                    <div class="comment-content">{{child.content}}</div>
                                                    <div class="comment-bottom">
                                                        <div class="comment-time">{{child.create_time|date_format('YYYY-MM-DD HH:mm')}}</div>
                                                        <div class="comment-btn-box">
                                                            <div :class="['comment-btn-items',{active:child.is_zan}]" @click="onUsefulClick(child,index,'child',ichild)">
                                                                <img v-if="!child.is_zan" src="@/assets/images/icon-mall-goods-detail-useful.png" alt="" class="btn-icon" />
                                                                <img v-else src="@/assets/images/icon-mall-goods-detail-useful-active.png" alt="" class="btn-icon" />
                                                                有用({{child.zan_count || 0}})
                                                            </div>
                                                            <div :class="['comment-btn-items',{active:child.commentting}]" @click="onCommentClick(child,index,'child',ichild)">
                                                                <img v-if="!child.commentting" src="@/assets/images/icon-mall-goods-detail-comment.png" alt="" class="btn-icon" />
                                                                <img v-else src="@/assets/images/icon-mall-goods-detail-comment-active.png" alt="" class="btn-icon" />
                                                                回复({{child.reply_count}})
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="reply-box" v-if="child.commentting">
                                                        <div class="reply-input">
                                                            <input placeholder="添加回复" v-model="reply_child" />
                                                        </div>
                                                        <div class="reply-btn" @click="onCommentReply">发送</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="false" class="more-evaluate">
                                    <div class="more-btn">
                                        加载更多评价<Icon type="ios-arrow-forward" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div ref="detailRight" :class="['detail-right',{'sticky-disabled':!is_right_sticky}]">
                <div class="collect-btn" @click.stop="onCollectProduct(detail.uuid)">
                    <img :src="detail.is_collected ? require('@/assets/images/icon-mall-collected.png'):require('@/assets/images/icon-mall-collect.png')" />{{detail.is_collected ? '已收藏' :'收藏'}}
                </div>
                <div class="goods-title">{{detail.name}}</div>
                <div class="goods-desc">
                    {{detail.description}}
                </div>
                <div class="goods-price">
                    <div v-if="price_start != price_end" class="sale-price">¥{{price_start}} ~ ¥{{ price_end }}</div>
                    <div v-else class="sale-price">¥{{price_start}}</div>
                    <div class="start-num">{{detail.mqq}}{{detail.unit}}起批</div>
                </div>
                <div class="tag-price">吊牌价¥{{detail.tag_price}}</div>
                <div class="goods-feature">
                    <div class="feature-item" v-if="detail.sale_mode != 1">
                        <img src="@/assets/images/icon-mall-logistics.png" alt="" />
                        48小时内发货      快递:免运费
                    </div>
                    <div class="feature-item" v-else>
                        <img src="@/assets/images/icon-mall-logistics.png" alt="" />
                        <div class="presale-box">
                            <div class="presale-tag">预售</div>
                            <span>
                                {{detail.presale_delivery_type == 2 ? `${detail.presale_promised_date}前发货`:`${detail.presale_delivery_days}天内发货`}}
                            </span>
                            <div class="line">|</div>
                            <span>快递:免运费</span>
                        </div>
                    </div>
                    <div class="feature-item">
                        <img src="@/assets/images/icon-mall-no-reason.png" alt="" />
                        7天无理由退货
                    </div>
                </div>
                <div class="goods-color-box">
                    <div class="goods-color-select">
                        <div class="color-label">选择颜色:</div>
                        <!-- <div class="color-value">{{ color_list && color_list.length > 0 ? color_list[current_color_index].name : '' }}</div> -->
                    </div>
                    <div class="goods-color-list">
                        <div :class="['color-list-item',{active:current_color_index == index}]" v-for="(item,index) in color_list" :key="index" @click="onColorSelect(item,index)" :title="item.name">
                            <img :src="item.color_image|default_img" alt="" class="color-content">
                            {{ item.name }}
                            <div class="num-tag" v-if="onColorCount(item)>0">{{onColorCount(item)}}</div>
                        </div>
                    </div>
                </div>
                <div class="goods-size-box">
                    <div class="goods-size-title">
                        <div class="size-title">选择尺寸</div>
                        <div v-if="false" class="size-table-btn" @click="show_size_table = true">尺码参数表</div>
                    </div>
                    <div class="goods-size-list">
                        <div class="size-list-item" v-for="(item,index) in size_list" :key="index" @click="onSizeSelect(item,index)">
                            <div class="size-name">{{ item.name }}</div>
                            <div class="price-num-box">
                                <div class="price" :title="`¥${item.price}`">¥{{item.price}}</div>
                                <div class="stock" :title="`库存${item.stock}件`">库存{{item.stock}}件</div>
                                <div class="num">
                                    <div @click="onNumMinus(index,item.spec_id)" :class="['change-btn','minus',{'disabled-btn':false}]">-</div>
                                    <Input class="num-input" :value="form.find(i => i.spec_id === item.spec_id) && form.find(i => i.spec_id === item.spec_id).num || 0"  @on-change="onNumInputChange($event, item)" />
                                    <div @click="onNumPlus(index,item.spec_id)" :class="['change-btn','plus',{'disabled-btn':false}]">+</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="total-count-box">
                        <div class="count-num">
                            已选<span>{{total_color}}</span>款<span>{{total_num}}</span>件
                        </div>
                        <div class="total-price">
                            商品金额:<span>¥{{total_price | price_format}}</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="select-count">选择数量</div>
                <div class="goods-count-box">
                    <div :class="['minus',{'disable-btn':form.num == 1}]" @click="onNumMinus">-</div>
                    <input v-model="form.num" />
                    <div class="plus" @click="onNumPlus">+</div>
                </div> -->
                <div class="goods-detail-btn-box">
                    <div class="add-cart-btn" @click="onJoinCart">加入购物车</div>
                    <div class="onbuy-btn" @click="onBuynow">立即购买</div>
                </div>
            </div>
        </div>
        <div class="detail-bottom" ref="like">
            <div class="bottom-title">—— 猜你喜欢 ——</div>
            <div class="bottom-list">
                <div class="goods-item" v-for="(item,index) in product_list" :key="index" @click.stop="$router.push({name:'GoodsDetail',params:{uuid:item.uuid}})">
                    <div class="goods-cover">
                        <img :src="item.image | default_img(false)" alt="" class="" />
                        <div class="collect-btn" @click.stop="onCollectProductForList(item.uuid,index)">
                            <!-- is_collected ? require('@/assets/images/icon-mall-collected.png'):require('@/assets/images/icon-mall-collect.png') -->
                            <img :src="item.is_collected ? require('@/assets/images/icon-mall-collected.png'):require('@/assets/images/icon-mall-collect.png')" alt="" class="collect-icon">
                            {{ item.is_collected ? '已收藏':'收藏' }}
                        </div>
                    </div>
                    <div class="goods-title">{{item.name}}</div>
                    <div class="goods-price">¥{{item.sale_price}}</div>
                    <div class="goods-author">
                        <img :src="(item.member || {}).avatar | default_img(false)" alt="" class="avatar" />
                        <div class="nickname">{{(item.member || {}).nickname || '匿名'}}</div>
                        <div class="line">|</div>
                        <div class="count-num">作品:{{(item.member || {}).works}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 尺码参照表 -->
        <popup :show.sync="show_size_table" @close="show_size_table = false" width="1200px" height="620px">
        <div class="size-table-popup">
            <div class="table-pop-header">
                尺码参数表
            </div>
            <div class="size-table-body">
                <table>
                    <thead>
                        <tr>
                            <th>尺码</th>
                            <th>衣长(cm)</th>
                            <th>胸围(cm)</th>
                            <th>肩宽(cm)</th>
                            <th>袖长(cm)</th>
                            <th>下摆(cm)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>155/80/S</td>
                            <td>68</td>
                            <td>104</td>
                            <td>52</td>
                            <td>30</td>
                            <td>20</td>
                        </tr>
                        <tr>
                            <td>155/80/S</td>
                            <td>68</td>
                            <td>104</td>
                            <td>52</td>
                            <td>30</td>
                            <td>20</td>
                        </tr>
                        <tr>
                            <td>155/80/S</td>
                            <td>68</td>
                            <td>104</td>
                            <td>52</td>
                            <td>30</td>
                            <td>20</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </popup>
        <!-- 加入购物车提示 -->
        <popup :show.sync="show_cart_success" @close="show_cart_success=false" width="540px" height="360px">
            <div class="add-cart-success">
                <img src="@/assets/images/icon-success.png" alt="" class="success-icon">
                <div class="success-title">已成功加入购物车</div>
                <div class="success-desc">您选的款式暂未锁定库存,请尽快付款~</div>
                <div class="btn-box">
                    <div class="continue-btn" @click="show_cart_success=false">继续购物</div>
                    <div class="shop-cart-btn" @click="$router.push({name:'MallShopCart'})">去购物车</div>
                </div>
            </div>
        </popup>
        <!-- 侧边栏 -->
        <mall-side></mall-side>
        <!-- 视频预览弹窗 -->
        <div v-if="show_video_preview" class="video-preview-mask" @click="closeVideoPreview">
            <div class="video-preview-container" @click.stop>
                <div class="video-preview-close" @click="closeVideoPreview">×</div>
                <video :src="preview_video_url" controls autoplay class="video-preview"></video>
            </div>
        </div>
    </div>
</template>
<script>
import {
    getMallProductDetail,
    getMallProductList,
    getSkuStock,
    MallCommentLike,
    MallCommentList,
    MallCommentReply,
    MallShopCollect,
    productCollect,
    productSpecStock,
    WholesaleAddCart
} from '@/api/index';
import Popup from '@/components/Popup.vue';
import util from '@/utils/util';
import MallSide from './components/MallSide.vue';
export default{
    data(){
        return{
            util,
            detail:{
                member:{}
            },
            current_img_index:0,
            current_color_index:0,
            current_size_index:0,
            show_prev_btn: false,
            show_next_btn: false,
            current_tab:'params',
            // form:{
            //     num:1,
            //     size_uuid:'',
            //     color_uuid:'',
            //     spec_id:''
            // },
            form:[
                // {spec_id:'',num:1}
            ],
            show_size_table:false,
            show_cart_success:false,
            is_right_sticky:true,
            uuid:'',
            comments:[],
            viewerOptions: {
                inline: false,
                button: true,
                navbar: true,
                title: true,
                toolbar: true,
                tooltip: true,
                movable: true,
                zoomable: true,
                rotatable: true,
                scalable: true,
                transition: true,
                fullscreen: true,
                keyboard: true,
                url: 'data-original'
            },
            reply_comment:'',
            reply_child:'',
            quote_uuid:'',
            product_list:[],
            curr_color:'',
            curr_size:'',
            curr_spec_id:'',
            spec_sizes:[],
            spec_obj:{},
            show_video_preview: false,
            preview_video_url: ''
        }
    },
    components:{MallSide,Popup},
    computed:{
        total_color(){
            const {form} = this;
            return form.filter((item)=>item.num >= 1).length || 0;
        },
        total_price(){
            const {detail,total_num,form} = this;
            if(!total_num) return '0';
            const {price_mode,price_step,product_spec,mqq} = detail;
            // 是否满足最小起订量：满足按批发/阶梯价，否则按零售价
            const isWholesale = Number(mqq) > 0 && total_num >= Number(mqq);

            // 阶梯定价
            if(price_mode == 2){
                if(isWholesale && price_step && Array.isArray(price_step) && price_step.length > 0){
                    // 满足 mqq：取 total_num 命中的阶梯 price
                    let price = Number((price_step[0] || {}).price) || 0;
                    price_step.filter(item=>item && typeof item === 'object').forEach(item => {
                        const itemMin = Number(item.min) || 0;
                        const itemPrice = Number(item.price) || 0;
                        if(total_num >= itemMin && itemPrice > 0){
                            price = itemPrice;
                        }
                    });
                    return (price * total_num).toFixed(2);
                }
                // 不满足 mqq：使用对应规格的 price 字段
                return form.reduce((acc,item)=>{
                    const spec = (product_spec && Array.isArray(product_spec))
                        ? product_spec.find(p => p && p.spec_id == item.spec_id)
                        : null;
                    const price = (spec && Number(spec.price)) || 0;
                    return acc + price * (item.num || 0);
                },0).toFixed(2);
            }

            // 规格定价：满足 mqq 用 wholesale_price，否则用 price
            return form.reduce((acc,item)=>{
                const spec = (product_spec && Array.isArray(product_spec))
                    ? product_spec.find(p => p && p.spec_id == item.spec_id)
                    : null;
                let price = 0;
                if(spec){
                    price = isWholesale && Number(spec.wholesale_price) > 0
                        ? Number(spec.wholesale_price)
                        : (Number(spec.price) || 0);
                }
                return acc + price * (item.num || 0);
            },0).toFixed(2);
        },
        total_num(){
            const {form} = this;
            //>计算form数组下所有对象中num的和
            return form.reduce((acc,item)=>{
                return acc + item.num;
            },0);
        },
        image_list(){
            const {image_list,image} = this.detail || {};
            if(Array.isArray(image_list) && image_list.length > 0){
                //>过滤 null / 非对象项，避免渲染期读取 item.raw 抛错
                return image_list.filter(item=>item && typeof item === 'object');
            }
            if(image){
                return [{raw:image,type:'image'}];
            }
            return [];
        },
        //>当前主图：索引越界或数据缺失时回退到第一张，绝不返回 undefined
        current_image(){
            const list = this.image_list;
            const index = Number(this.current_img_index) || 0;
            const item = list[index] || list[0];
            return (item && typeof item === 'object') ? item : {raw:'',type:'image'};
        },
        color_list(){
            const group = (this.detail && this.detail.spec_group) || {};
            const color = Array.isArray(group.color) ? group.color : [];
            return color.filter(item=>item && typeof item === 'object');
        },
        size_list(){
            if(!Array.isArray(this.spec_sizes)) return [];

            const {total_num} = this;
            const {price_mode,price_step,product_spec,mqq} = this.detail || {};
            const specs = Array.isArray(product_spec) ? product_spec : [];
            const steps = Array.isArray(price_step) ? price_step.filter(i=>i && typeof i === 'object') : [];

            return this.spec_sizes
                .filter(item=>item && typeof item === 'object')
                .map(item=>{
                    // 从 form 中查找对应 spec_id 的 num 值
                    const formItem = this.form.find(f => f && f.spec_id === item.spec_id);
                    const num = formItem ? formItem.num : 0;
                    // 默认按规格零售价显示
                    let price = Number(item.price) || 0;

                    if(price_mode == 1){
                        // 从 product_spec 查找当前规格的零售价与批发价
                        const spec = specs.find(p => p && p.spec_id == item.spec_id) || null;
                        price = (spec && Number(spec.price)) || price;
                        // 数量达到最小起订量时按批发价显示
                        if(Number(mqq) > 0 && total_num >= Number(mqq) && spec && Number(spec.wholesale_price) > 0){
                            price = Number(spec.wholesale_price);
                        }
                    }else if(price_mode == 2){
                        if(steps.length > 0){
                            if(total_num == 0){
                                price = Number(steps[0].price) || 0;
                            }
                            const validSteps = steps.filter(i => total_num >= Number(i.min));
                            if(validSteps.length > 0){
                                price = Number(validSteps[validSteps.length - 1].price) || 0;
                            }
                        }
                    }
                    //>price_mode 非 1/2（历史脏数据 0/null）时走上面的默认零售价兜底，绝不返回 undefined
                    return {
                        ...item,
                        name: item.attr_name || '',
                        uuid: item.attr_uuid || '',
                        spec_id: item.spec_id,
                        price,
                        num: num  // 从 form 读取
                    }
                });
        },
        tableParams() {
            // 将参数转换为表格行格式，每行包含两个参数（键值对）
            const params = Array.isArray(this.detail.param)
                ? this.detail.param.filter(item=>item && typeof item === 'object')
                : [];
            const rows = [];

            // 每两个参数为一行
            for (let i = 0; i < params.length; i += 2) {
                const row = [];
                // 添加第一个参数的键和值
                row.push(params[i].key || '');
                row.push(params[i].value || '');

                // 添加第二个参数的键和值（如果存在）
                if (i + 1 < params.length) {
                    row.push(params[i + 1].key || '');
                    row.push(params[i + 1].value || '');
                } else {
                    // 如果没有第二个参数，添加空单元格以保持表格结构
                    row.push('');
                    row.push('');
                }

                rows.push(row);
            }

            return rows;
        },
        price_start(){
            const {price_mode,price_step,product_spec} = this.detail || {};
            const steps = Array.isArray(price_step) ? price_step.filter(i=>i && isFinite(Number(i.price))) : [];
            if(price_mode == 2 && steps.length > 0){
                return Math.min(...steps.map(item=>Number(item.price)));
            }
            const specs = Array.isArray(product_spec) ? product_spec.filter(i=>i && isFinite(Number(i.wholesale_price))) : [];
            if(specs.length > 0){
                //>取product_spec数组对象中price属性值最小的一个
                return Math.min(...specs.map(item=>Number(item.wholesale_price)));
            }
            return '0';
        },
        price_end(){
            const {price_mode,price_step,product_spec} = this.detail || {};
            const steps = Array.isArray(price_step) ? price_step.filter(i=>i && isFinite(Number(i.price))) : [];
            if(price_mode == 2 && steps.length > 0){
                return Math.max(...steps.map(item=>Number(item.price)));
            }
            const specs = Array.isArray(product_spec) ? product_spec.filter(i=>i && isFinite(Number(i.wholesale_price))) : [];
            if(specs.length > 0){
                //>取product_spec数组对象中price属性值最大的一个
                return Math.max(...specs.map(item=>Number(item.wholesale_price)));
            }
            return '0';
        }
    },
    watch:{
        current_tab(newVal){
            this.scrollToRef(newVal);
        },
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            // 通过 `vm` 访问组件实例
            // vm.$emit("showFooter", false);
            vm.$emit('changeFooter','mall');
        });
    },
    beforeRouteUpdate(to, from, next) {
        // 处理同组件路由跳转
        const {uuid} = to.params;
        if(uuid && uuid !== this.uuid){
            this.uuid = uuid;
            this.current_tab = 'params';
            this.onGetDetail();
            this.$nextTick(()=>{
                window.scrollTo({
                    top:0,
                    behavior:'smooth'
                })
            })
            next();
        } else {
            next();
        }
    },
    async mounted(){
        const {uuid} = this.$route.params;
        if(!uuid){
            this.$layer.msg('商品不存在[uuid]');
            this.$router.back();
            return;
        }
        this.uuid = uuid;
        // await this.onGetDetail();
        await Promise.all([
            this.onGetComments(),
            this.onGetDetail(),
            this.onGetMallProductList()
        ])
        this.$nextTick(() => {
            this.checkScrollButtons();
            this.$nextTick(()=>{
                this.$refs.imgList.addEventListener('scroll', this.checkScrollButtons);
            })
            window.addEventListener('scroll', this.handleScroll,{passive:true});
            this.handleScroll();
        });
    },
    beforeDestroy() {
        if (this.$refs.imgList) {
            this.$refs.imgList.removeEventListener('scroll', this.checkScrollButtons);
        }

        window.removeEventListener('scroll', this.handleScroll);
    },
    //>兜底：子组件（popup / mall-side / Icon 等）渲染或生命周期内抛错时，
    //>不让错误继续向上传播打断整页渲染
    errorCaptured(err, vm, info) {
        console.warn('[GoodsDetail] 子组件异常已拦截:', info, err);
        return false;
    },
    methods:{
        onColorCount(data){
            // console.log(data);
            const {form} = this;
            return form.reduce((acc,item)=>{
                // 校验 item 是否存在且 color 匹配
                if(!item || item.color !== data.uuid){
                    return acc;
                }
                // 确保 num 是有效数字
                const num = Number(item.num);
                const validNum = isNaN(num) ? 0 : num;
                return acc + validNum;
            },0);
            // return '0';
        },
        onNumInputChange(event, item){
            let num = parseInt(event.target.value) || 0;
            if(num > item.stock){
                num = item.stock;
                this.$layer.msg(`库存不足，最多可购买${item.stock}件`);
            }
            const validNum = num > 0 ? num : 1;

            // 只更新 form 数组
            const index = this.form.findIndex(f => f.spec_id === item.spec_id);
            if(index !== -1){
                this.form.splice(index, 1, {
                    ...this.form[index],
                    num: validNum
                });
            }
        },
        async onGetSpecStock(uuid){
            try{
                const {code,data,msg} = await productSpecStock({uuid,type:2});
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                // console.log('data',data);
                // this.spec_sizes = data;
                //>过滤掉 null / 缺少 attr_uuid 的项，避免后续读 item.attr_uuid 抛错
                const list = (Array.isArray(data) ? data : []).filter(item=>item && item.attr_uuid);
                if(!list.length){
                    this.spec_sizes = [];
                    return;
                }
                const new_data = await Promise.all(list.map(async (item)=>{
                    this.curr_size = item.attr_uuid;
                    const spec_id = await this.onSpecCheck(true);
                    return {
                        ...item,
                        spec_id
                    }
                }))
                // console.warn('new_data----->',new_data);
                this.spec_sizes = new_data.filter(item=>item && typeof item === 'object');
            }catch(e){
                console.log('err-spec-stock',e);
            }
        },
        async onCollectProductForList(uuid,index){
            try{
                const {code,msg} = await productCollect({uuid});
                if(code > 0){
                this.$layer.msg(msg);
                return;
                }
                //>列表可能已被刷新，索引越界时直接跳过，避免读 undefined.is_collected
                const target = this.product_list[index];
                if(!target) return;
                target.is_collected = !target.is_collected;
                this.$layer.msg('操作成功~');
            }catch(e){
                console.log('err-collect',e);
            }
        },
        async onGetMallProductList(){
            const {code,data,msg} = await getMallProductList({page:1,size:15});
            if(code > 0){
                this.$layer.msg(msg);
                return;
            }
            const list = (data && Array.isArray(data.list)) ? data.list : [];
            //>过滤 null 项并补齐 member，模板里 item.member.avatar 等不再裸读
            this.product_list = list
                .filter(item=>item && typeof item === 'object')
                .map(item=>({
                    ...item,
                    member: (item.member && typeof item.member === 'object') ? item.member : {}
                }));
            this.total = Number(data && data.count) || 0;
        },
        scrollToRef(tab) {
            const refMap = {
                'params': 'params',
                'detail': 'detail',
                'evaluate': 'evaluate',
                'like': 'like'
            };

            const refName = refMap[tab];
            if (!refName || !this.$refs[refName]) {
                return;
            }

            const element = this.$refs[refName];
            if (!element) return;

            const offsetTop = element.offsetTop;
            const scrollTop = offsetTop - 100; // 减去顶部偏移量，避免贴顶

            window.scrollTo({
                top: scrollTop,
                behavior: 'smooth'
            });
        },
        async onCommentReply(){
            try{
                const {reply_comment,uuid,quote_uuid,reply_child} = this;
                const param = {};
                param.product_uuid = uuid;
                param.quote_uuid = quote_uuid;
                param.content = reply_comment || reply_child;
                const {code,msg} = await MallCommentReply(param);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('评论成功~');
                //>刷新列表
                this.onGetComments();
            }catch(e){
                console.log('comment-replay-err',e);
                this.$layer.msg(e.msg);
            }
        },
        async onGetComments(){
            try{
                const {code,msg,data} = await MallCommentList({uuid:this.uuid});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data-comments',data);
                //>统一归一化：缺失的 frommember/tomember/image_list/children 都补默认值，
                //>模板里 item.frommember.avatar、child.frommember.nickname 等不再裸读抛错
                const toObj = (v)=>(v && typeof v === 'object') ? v : {};
                const list = Array.isArray(data) ? data : [];
                this.comments = list
                    .filter(item=>item && typeof item === 'object')
                    .map((item)=>({
                        ...item,
                        frommember:toObj(item.frommember),
                        tomember:toObj(item.tomember),
                        image_list:Array.isArray(item.image_list)
                            ? item.image_list.filter(pic=>pic && (typeof pic === 'string' || typeof pic === 'object'))
                            : [],
                        commentting:false,
                        children:(Array.isArray(item.children) ? item.children : [])
                            .filter(child=>child && typeof child === 'object')
                            .map((child)=>({
                                ...child,
                                frommember:toObj(child.frommember),
                                tomember:toObj(child.tomember),
                                commentting:false
                            }))
                    }));
            }catch(e){
                console.log(' err-on-get-comments',e);
                this.$layer.msg(e.msg);
            }
        },
        async onShopCollect(){
            try{
                const {code,msg} = await MallShopCollect({shop_id:this.detail.shop_id});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.onGetDetail();
            }catch(e){
                console.log('err-shop-collect',e);
            }
        },
        onBuynow(){
            // if(this.total_num < this.detail.mqq){
            //     this.$layer.msg(`该商品最小购买数量为${this.detail.mqq}件`);
            //     return;
            // }
            const param = {};
            // param.spec_id = this.form.spec_id;
            // param.num = this.form.num;
            param.wholesale_data = JSON.stringify(this.form.filter(item=>Number(item.num)>0).map(item=>{
                return {
                    spec_id:item.spec_id,
                    num:item.num
                }
            }));
            param.from = 'buynow';
            param.product_uuid = this.detail.uuid;
            if(!param.wholesale_data.length){
                this.$layer.msg('请选择商品规格和数量~');
                return;
            }
            this.$router.push({name:'MallCheckOut',query:param})
        },
        async onSpecCheck(no_spec_check=false){
            try{
                const {curr_color,curr_size} = this;
                const {uuid} = this.detail || {};
                if(!curr_color || !curr_size || !uuid) return;
                const {code,msg,data} = await getSkuStock({product_uuid:uuid,size_uuid:curr_size,color_uuid:curr_color})
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                // console.log('data-spec',data);
                //>接口没返回有效规格对象时直接退出，避免后面读 data.spec_id 抛错
                if(!data || typeof data !== 'object') return;
                this.spec_obj = data;
                this.curr_spec_id = data.spec_id;
                if(!no_spec_check)this.onGetSpecStock(curr_color);
                //> 查找form数组中是否有存在此spec_id
                const find_spec = this.form.findIndex(item=>item.spec_id == data.spec_id);
                // console.log('spec-check-find_spec',find_spec);
                if(find_spec == -1){
                    this.form.push({spec_id:data.spec_id,num:0,color:curr_color,size:curr_size});
                }
                // console.log('this.form---',this.form);
                // this.form.spec_id = data.spec_id;
                return data.spec_id;
            }catch(e){
                console.warn('err-spec-stock',e);
            }
        },
        async onCollectProduct(uuid){
            try{
                const {code,msg} = await productCollect({uuid});
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.onGetDetail();
            }catch(e){
                console.log('err-collect',e);
            }
        },
        onSizeSelect(item,index){
            this.current_size_index = index;
            // this.form.size_uuid = item.uuid;
            this.curr_size = item.uuid;
            // this.onSpecCheck()
        },
        onColorSelect(item,index){
            this.current_color_index = index;
            // this.form.color_uuid = item.uuid;
            this.curr_color = item.uuid;
            // onSpecCheck 内部在 no_spec_check=false 时会调用 onGetSpecStock，
            // 这里只调用 onGetSpecStock 即可，避免重复调用导致数据重复
            this.onGetSpecStock(item.uuid);
        },
        async onGetDetail(){
            try{
                const {code,data,msg} = await getMallProductDetail({uuid:this.uuid});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data-detail',data);
                //>接口没返回有效对象时直接退出，避免后续 detail.xxx 裸读
                if(!data || typeof data !== 'object'){
                    this.$layer.msg('商品数据异常');
                    return;
                }
                // 商品已下架,跳转下架页
                if(data.is_available == 0){
                    const uid = data.member && data.member.code ? data.member.code : '';
                    this.$router.replace({name:'GoodsOffline', query:{uid}});
                    return;
                }
                this.detail = data;
                //>换商品时重置主图索引，避免 current_img_index 越界
                this.current_img_index = 0;
                //>color_list 为空时不再取 [0].uuid，直接跳过规格加载
                const first_color = this.color_list[0];
                if(first_color){
                    this.onColorSelect(first_color,0);
                }
                // this.onSizeSelect(this.size_list[0],0);

            }catch(e){
                console.log('err-get-detail',e);
            }
        },
        handleScroll() {
            //   console.log('handleScroll triggered');
            // 获取 detail-wrapper 元素
            // console.log('this.$refs.detailRight',this.$refs.detailRight,'query-selector',this.$refs.detailRight.querySelector);
            // console.log('dw===>',this.$refs.detailRight.querySelector('.detail-wrapper'));
            // const detailWrapper = document.querySelector('.detail-wrapper');
            const detailWrapper = document.querySelector('.detail-bottom');
            // console.log('detail_wrapper',detailWrapper);

            if(detailWrapper){
                // 获取元素的位置信息
                const rect = detailWrapper.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                // 检查 detail-wrapper 的底部是否进入视窗
                // 当元素底部距离页面顶部的距离小于窗口高度时，表示底部已经可见
                if (rect.bottom <= windowHeight) {
                    this.is_right_sticky = false;
                } else {
                    this.is_right_sticky = true;
                }
            }
        },
        async onJoinCart(){
            try{
                // const {size_uuid,color_uuid} = this.form;
                // if(!size_uuid){
                //     this.form.size_uuid = this.size_list && this.size_list.length > 0 ? this.size_list[0].uuid : '';
                // }
                // if(!color_uuid){
                //     this.form.color_uuid = this.color_list && this.color_list.length > 0 ? this.color_list[0].uuid : '';
                // }
                // if(!this.form.size_uuid || !this.form.color_uuid){
                //     this.$layer.msg('商品缺货或未选颜色尺码,请重新核对');
                //     return;
                // }
                if(!this.form.length){
                    this.$layer.msg('请选择商品规格和数量~');
                    return;
                }
                const param = {};
                param.data = this.form.filter((item)=>item.num>0).map(item=>{
                    return {
                        spec_id:item.spec_id,
                        num:item.num
                    }
                })
                const {code,msg} = await WholesaleAddCart(param);
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                this.show_cart_success = true;
            }catch(e){
                console.log('err-join-cart',e);
                this.$layer.msg(e.msg);
            }
        },
        onCommentClick(item,index,type,child_index){
            console.log('item==>',item,'child_index==>',child_index);
            this.quote_uuid = item.uuid;
            if(type === 'parent'){
                const {commentting} = this.comments[index];
                this.comments[index].commentting = !commentting;
            }else{
                const {commentting} = this.comments[index].children[child_index];
                this.comments[index].children[child_index].commentting = !commentting;
            }
        },
        async onUsefulClick(item,index,type,child_index){
            try{
                console.log('item==>',item,'child_index==>',child_index);
                const param = {};
                param.uuid = item.uuid;
                const {code,msg} = await MallCommentLike(param);
                if(code>0){
                     this.$layer.msg(msg);
                     return;
                }
                this.$layer.msg('操作成功~');
                if(type === 'parent'){
                    const {is_zan,zan_count} = this.comments[index];
                    this.comments[index].is_zan = !is_zan;
                    this.comments[index].zan_count = is_zan ? zan_count - 1 :zan_count + 1;

                }else{
                    const {is_zan,zan_count} = this.comments[index].children[child_index];
                    console.log('is_zan-child',is_zan)
                    console.log('userful->',is_zan);
                    this.comments[index].children[child_index].is_zan = !is_zan;
                    this.comments[index].children[child_index].zan_count = is_zan ? zan_count - 1 : zan_count + 1;
                }
            }catch(e){
                console.log('err-comment-zan',e);
                this.$layer.msg(e.msg);
            }
        },
        onNumPlus(index,spec_id){
            // console.log('numplus-item',spec_id);
            const { form, size_list } = this;
            // console.log('numplus-form',form);
            const formIndex = form.findIndex(f => f.spec_id === spec_id);
            // console.log('formindex',formIndex);
            if(formIndex !== -1){
                const currentNum = form[formIndex].num || 0;
                const stockItem = (size_list || []).find(item => item.spec_id === spec_id) || {};
                const stock = Number(stockItem.stock) || 0;
                // 越界锁：已达库存上限则禁止继续加
                if(currentNum >= stock){
                    this.$layer.msg(`库存不足，最多可购买${stock}件`);
                    return;
                }
                const newNum = currentNum + 1;
                // this.form.splice(formIndex, 1, {
                //     ...form[formIndex],
                //     num: newNum
                // });
                this.$set(this.form[formIndex],'num',newNum);
            }
        },
        onNumMinus(index,spec_id){
            const { form } = this;

            const formIndex = form.findIndex(f => f.spec_id === spec_id);
            if(formIndex !== -1){
                const currentNum = form[formIndex].num || 0;
                if(currentNum <= 0){
                    this.$layer.msg('不能再减了~');
                    return;
                }
                const newNum = currentNum - 1;
                // this.form.splice(formIndex, 1, {
                //     ...form[formIndex],
                //     num: newNum
                // });
                this.$set(this.form[formIndex],'num',newNum);
            }
        },
        checkScrollButtons() {
            const imgList = this.$refs.imgList;
            if (!imgList) return;

            const scrollTop = imgList.scrollTop;
            const scrollHeight = imgList.scrollHeight;
            const clientHeight = imgList.clientHeight;

            // 当滚动到顶部时隐藏prev按钮
            this.show_prev_btn = scrollTop > 0;

            // 当滚动到底部时隐藏next按钮
            this.show_next_btn = scrollTop + clientHeight < scrollHeight;
        },

        scrollImgList(direction) {
            const imgList = this.$refs.imgList;
            if (!imgList) return;

            const scrollAmount = 178 + 9; // 图片高度 + 间距
            const currentScrollTop = imgList.scrollTop;

            if (direction === 'up') {
                imgList.scrollTo({
                    top: Math.max(0, currentScrollTop - scrollAmount),
                    behavior: 'smooth'
                });
            } else if (direction === 'down') {
                imgList.scrollTo({
                    top: currentScrollTop + scrollAmount,
                    behavior: 'smooth'
                });
            }

            // 滚动完成后检查按钮状态
            setTimeout(() => {
                this.checkScrollButtons();
            }, 300);
        },
        onPreviewVideo(url) {
            this.preview_video_url = url;
            this.show_video_preview = true;
        },
        closeVideoPreview() {
            this.show_video_preview = false;
            this.preview_video_url = '';
        }
    }
}
</script>
<style lang="scss" scoped>
.goods-detail{
    width:100%;
    background:rgb(250,250,250);
    display:flex;
    // justify-content:center;
    align-items:center;
    flex-direction:column;
    // column-gap:38px;
    padding-top:25px;
    padding-bottom:50px;
    user-select:none;
    .detail-top{
        width:100%;
        display:flex;
        justify-content:center;
        column-gap:38px;
        .detail-left{
            // width:842px;
            max-width:842px;
            flex:0 0 54.32%;
            max-height:100%;
            display:flex;
            flex-direction:column;
            // overflow-y:auto;
            .shop-author-info{
                width:100%;
                display:flex;
                align-items:center;
                justify-content:space-between;
                .author-left{
                    display:flex;
                    align-items:center;
                    column-gap:17px;
                    .author-avatar{
                        width:60px;
                        height:60px;
                        border-radius:10px;
                        border:1px solid #cccccc;
                        background:#ebebeb;
                    }
                    .author-info{
                        display:flex;
                        flex-direction:column;
                        justify-content:center;
                        row-gap:15px;
                        .shop-name{
                            color:#1a1a1a;
                            font-size:16px;
                            font-weight:bold;
                        }
                        .author-info-line{
                            display:flex;
                            align-items:center;
                            column-gap:28px;
                            .desc{
                                color:#666666;
                                font-size:12px;
                            }
                            .count{
                                color:#666666;
                                font-size:12px;
                            }
                        }
                    }
                }
                .author-right{
                    display:flex;
                    align-items:center;
                    column-gap:12px;
                    .btn-item{
                        width:78px;
                        height:40px;
                        line-height:40px;
                        border:1px solid #e0e0e0;
                        border-radius:6px;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        column-gap:3px;
                        cursor:pointer;
                        .btn-icon{
                            width:20px;
                            height:20px;
                        }
                        &.shop-collected{
                            background:#ff5967;
                            color:#ffffff;
                        }
                    }
                }
            }
            .goods-img-box{
                width:100%;
                height:740px;
                display:flex;
                column-gap:22px;
                overflow:hidden;
                margin-top:20px;
                .img-list{
                    width:160px;
                    height:100%;
                    display:flex;
                    flex-direction: column;
                    row-gap:9px;
                    overflow-y:scroll;
                    border-radius:6px;
                    overflow-x:hidden;
                    // position:relative;
                    .prev, .next{
                        width:100%;
                        height:32px;
                        background:#ffffff;
                        cursor:pointer;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        position:sticky;
                        left:0;
                        z-index:20;
                        border:1px solid #e0e0e0;
                        flex-shrink:0;
                        overflow:hidden;
                    }
                    .prev{
                        top:0;
                        border-radius:6px 6px 0 0;
                    }
                    .next{
                        bottom:0;
                        border-radius:0 0 6px 6px;
                    }
                    &::-webkit-scrollbar{
                        display:none;
                    }
                    .img-item{
                        width:100%;
                        height:178px;
                        background:#ffffff;
                        border-radius:6px;
                        border:1px solid #e0e0e0;
                        display: flex;
                        align-items:center;
                        justify-content:center;
                        overflow:hidden;
                        flex-shrink:0;
                        position: relative;
                        .player-icon{
                            width:100%;
                            height:100%;
                            display:flex;
                            align-items:center;
                            justify-content:center;
                            position:absolute;
                            top:0;
                            left:0;
                            img{
                                width:40px;
                                height:40px;
                                object-fit:cover;
                            }
                        }
                        &.active, &:hover{
                            border:2px solid #ff5967;
                        }
                        img{
                            width:100%;
                            // height:auto;
                            height:100%;
                            object-fit:contain;
                            object-position:center;
                            border-radius:6px;
                        }
                    }
                }
                .main-img{
                    width:660px;
                    height:100%;
                    border-radius:6px;
                    background:#ffffff;
                    overflow:hidden;
                    img{
                        object-fit: contain;
                    }
                    video{
                        width:100%;
                        height:100%;
                        background:#000000;
                    }
                }
            }
            .detail-box{
                width:100%;
                border-radius:6px;
                background:#ffffff;
                margin-top:20px;
                padding-bottom:60px;
                .detail-tabs{
                    width:100%;
                    border-bottom:1px solid #e6e6e6;
                    padding:30px 20px 20px 20px;
                    display:flex;
                    align-items:center;
                    column-gap:39px;
                    &.tabs-sticky{
                        position:sticky;
                        //top:80px;
                        top:7vh;
                        z-index:99;
                        background:#fff;
                        padding-top:20px;
                    }
                    .tabs-item{
                        color:#333333;
                        font-size:16px;
                        line-height:36px;
                        cursor:pointer;
                        &.active, &:hover{
                            color:#ff5967;
                            font-weight:bold;
                            position:relative;
                            &::after{
                                content:"";
                                position:absolute;
                                width:100%;
                                height:2px;
                                background:#ff5967;
                                left:0;
                                bottom:-21px;
                            }
                        }
                    }
                }
                .detail-wrapper{
                    width:100%;
                    margin-top:38px;
                    padding:0 20px;
                    display:flex;
                    flex-direction:column;
                    .part-title{
                        color:#1a1a1a;
                        font-size:20px;
                        line-height:36px;
                        font-weight:400;
                    }
                    .params-table {
                        width: 100%;
                        margin-top: 25px;
                        margin-bottom:40px;
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            border:1px solid #ebebeb;
                            border-radius: 6px;
                            td {
                                padding: 12px 16px;
                                text-align: left;
                                vertical-align: top;
                                border-right: 1px solid #e6e6e6;

                                &:last-child {
                                    border-right: none;
                                }
                            }

                            .label {
                                background-color: #f9fafc;
                                font-size: 14px;
                                font-weight: 500;
                                width: 130px;
                                padding: 12px 16px;
                                border-right: 1px solid #e6e6e6;
                                color:#333333;
                            }

                            .value {
                                color: #333333;
                                font-size: 14px;
                                padding: 12px 16px;
                                border-bottom: 1px solid #e6e6e6;

                            }

                            tr:last-child td {
                                border-bottom: none;
                            }

                        }
                    }
                    .detail-content{
                        width:100%;
                        margin-top:30px;
                        margin-bottom:30px;
                        max-height:1500px;
                        overflow-y:auto;
                    }
                    .evaluate-part{
                        width:100%;
                        .top-part{
                            width:100%;
                            display:flex;
                            align-items:center;
                            justify-content:space-between;
                            .top-part-title{
                                color:#1a1a1a;
                                font-size:20px;
                            }
                            .sort-btn{
                                width:110px;
                                height:42px;
                                border:1px solid #d6d6d6;
                                display:flex;
                                align-items:center;
                                justify-content:center;
                                border-radius:6px;
                                cursor:pointer;
                            }
                        }
                        .evaluate-list{
                            width:100%;
                            display: flex;
                            flex-direction:column;
                            row-gap:34px;
                            margin-top:38px;
                            .evaluate-item{
                                width:100%;
                                display:flex;
                                column-gap:13px;
                                .user-avatar{
                                    width:44px;
                                    height:44px;
                                    border:1px solid #cccccc;
                                    background:#ebebeb;
                                    border-radius:50%;
                                }
                                .item-content{
                                    flex:1;
                                    display:flex;
                                    flex-direction:column;
                                    .user-name{
                                        color:#333333;
                                        font-size:16px;
                                        font-weight:400;
                                    }
                                    .date-spec{
                                        color:#999999;
                                        font-size:14px;
                                        span{
                                            margin-right:10px;
                                        }
                                    }
                                    .evaluate-content{
                                        color:#333333;
                                        font-size:14px;
                                        margin-top:15px;
                                        margin-bottom:20px;
                                    }
                                    .evaluate-img-list{
                                        width:100%;
                                        display:flex;
                                        flex-wrap:wrap;
                                        gap:12px;
                                        .evaluate-img-item{
                                            width:140px;
                                            max-height:140px;
                                            border-radius:6px;
                                            background:#ebebeb;
                                            overflow:hidden;
                                            display:flex;
                                            align-items:center;
                                            justify-content:center;
                                            position:relative;
                                            >img{
                                                width:100%;
                                                height:auto;
                                                object-fit:contain;
                                                object-position:center;
                                            }
                                            .video-play{
                                                position:absolute !important;
                                                top:50% !important;
                                                left:50% !important;
                                                transform:translate(-50%,-50%) !important;
                                                width:16px !important;
                                                height:16px !important;
                                                z-index:9 !important;
                                            }
                                        }
                                    }
                                    .comment-like-box{
                                        display:flex;
                                        align-items:center;
                                        column-gap:19px;
                                        margin-top:15px;
                                        .box-item{
                                            display:flex;
                                            align-items:center;
                                            column-gap:6px;
                                            color:#808080;
                                            font-size:12px;
                                            cursor:pointer;
                                            &.active{
                                                color:#ff5967;
                                            }
                                            .item-icon{
                                                width:20px;
                                                height:20px;
                                            }
                                        }
                                    }
                                    .reply-box{
                                        width:100%;
                                        display:flex;
                                        align-items:center;
                                        column-gap:10px;
                                        margin-top:24px;
                                        .reply-input{
                                            flex:1;
                                            background:#f2f4f7;
                                            border-radius:4px;
                                            height:38px;
                                            padding:0 12px;
                                            input{
                                                width:100%;
                                                height:100%;
                                                border:none;
                                                outline:none;
                                                background:transparent;
                                            }
                                        }
                                        .reply-btn{
                                            width:86px;
                                            height:38px;
                                            border-radius:4px;
                                            background:#ff5967;
                                            color:#ffffff;
                                            text-align:center;
                                            line-height:38px;
                                            cursor:pointer;
                                            user-select:none;
                                        }
                                    }
                                    .child-comment-box{
                                        margin-top:30px;
                                        width:100%;
                                        display:flex;
                                        flex-direction:column;
                                        row-gap:20px;
                                        .child-comment-item{
                                            display:flex;
                                            column-gap:10px;
                                            .child-comment-avatar{
                                                width:36px;
                                                height:36px;
                                                background:#ebebeb;
                                                border:1px solid #cccccc;
                                                border-radius:50%;
                                            }
                                            .child-comment-content{
                                                display:flex;
                                                flex-direction:column;
                                                width:100%;
                                                .comment-user-name{
                                                    color:#333333;
                                                    font-size:16px;
                                                    line-height:36px;
                                                }
                                                .comment-content{
                                                    color:#333333;
                                                    font-size:14px;
                                                    line-height:36px;
                                                }
                                                .comment-bottom{
                                                    width:100%;
                                                    display:flex;
                                                    align-items:center;
                                                    justify-content:space-between;
                                                    .comment-time{
                                                        color:#999999;
                                                        font-size:14px;
                                                        line-height:36px;
                                                    }
                                                    .comment-btn-box{
                                                        display:flex;
                                                        align-items:center;
                                                        column-gap:26px;
                                                        .comment-btn-items{
                                                            display:flex;
                                                            column-gap:8px;
                                                            color:#808080;
                                                            font-size:12px;
                                                            cursor:pointer;
                                                            user-select:none;
                                                            &.active{
                                                                color:#ff5967;
                                                            }
                                                            .btn-icon{
                                                                width:16px;
                                                                height:17px;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            .more-evaluate{
                                width:100%;
                                display:flex;
                                align-items:center;
                                justify-content:center;
                                margin-top:8px;
                                .more-btn{
                                    width:150px;
                                    height:42px;
                                    display:flex;
                                    align-items:center;
                                    justify-content:center;
                                    font-size:14px;
                                    color:#333333;
                                    border:1px solid #d6d6d6;
                                    border-radius:6px;
                                    cursor:pointer;
                                }
                            }
                        }
                    }
                }
            }
        }
        .detail-right{
            // width:670px;
            max-width:670px;
            flex:0 0 43.23%;
            height:fit-content;
            align-self:flex-start;
            background:#ffffff;
            border-radius:6px;
            position:sticky;
            top:15%;
            padding:0 50px;
            // padding-bottom:50px;
            display:flex;
            flex-direction:column;
            &.sticky-disabled{
                position:static;
                top:auto;
                align-self:flex-end;
            }
            .collect-btn{
                position:absolute;
                top:18px;
                right: 24px;
                display:flex;
                align-items:center;
                color:#999999;
                font-size:13px;
                cursor:pointer;
                img{
                    width:20px;
                    height:20px;
                }
            }
            .goods-title{
                color:#1a1a1a;
                font-size:22px;
                font-weight:bold;
                margin-top:30px;
            }
            .goods-price{
                display:flex;
                align-items:baseline;
                column-gap:13px;
                margin-top:10px;
                .sale-price{
                    color:#fe3d4d;
                    font-size:24px;
                    font-weight:bold;
                }
                .start-num{
                    color:#666;
                    font-size:12px;
                }
            }
            .tag-price{
                color:#999999;
                font-size:14px;
                text-decoration:line-through;
                // margin-top:12px;
            }
            .goods-desc{
                color:#4d4d4d;
                font-size:14px;
                // line-height:28px;
                margin-top:18px;
            }
            .goods-feature{
                width:100%;
                display:flex;
                flex-direction:column;
                row-gap:5px;
                margin-top:20px;
                .feature-item{
                    display:flex;
                    column-gap:9px;
                    align-items:center;
                    color:#4d4d4d;
                    font-size:13px;
                    img{
                        width:22px;
                        height:22px;
                    }
                    .presale-box{
                        display:flex;
                        align-items:center;
                        column-gap:5px;
                        color:#4d4d4d;
                        font-size:13px;
                        .line{
                            color:#ccc;
                        }
                        .presale-tag{
                            color:#ff5967;
                            // padding:4px 8px;
                            padding:0 8px;
                            line-height:20px;
                            border-radius:4px;
                            border:1px solid #ff5967;
                        }
                    }
                }
            }
            .goods-color-box{
                width:100%;
                margin-top:36px;
                display:flex;
                flex-direction:column;
                row-gap:20px;
                .goods-color-select{
                    display:flex;
                    align-items:center;
                    .color-label{
                        color:#666666;
                        font-size:14px;
                        // line-height:36px;
                    }
                    .color-value{
                        color:#1a1a1a;
                        font-size:14px;
                        // line-height:36px;
                    }
                }
                .goods-color-list{
                    width:100%;
                    display:flex;
                    align-items:center;
                    column-gap:10px;
                    flex-wrap:wrap;
                    .color-list-item{
                        width:auto;
                        // width:42.25px;
                        // height:42.25px;
                        height:40px;
                        display:flex;
                        align-items:center;
                        column-gap:6px;
                        // justify-content:center;
                        border-radius:3px;
                        cursor:pointer;
                        padding-right:15px;
                        color:#333;
                        font-size:14px;
                        position:relative;
                        border:1px solid #ebebeb;
                        .num-tag{
                            background:#ff5967;
                            color:#fff;
                            border-radius:8px;
                            padding:0px 6px;
                            font-size:12px;
                            position:absolute;
                            left:-1px;
                            top:-20%;
                        }
                        &.active{
                            border:1px solid #ff5967;
                        }
                        .color-content{
                            width:40px;
                            height:100%;
                            border-top-left-radius:3px;
                            border-bottom-left-radius:3px;
                            object-fit:cover;
                            object-position:center;
                        }
                    }
                }
            }
            .goods-size-box{
                display:flex;
                flex-direction:column;
                row-gap:20px;
                margin-top:30px;
                width:100%;
                .goods-size-title{
                    width:100%;
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    .size-title{
                        color:#666666;
                        font-size:14px;
                    }
                    .size-table-btn{
                        color:#999999;
                        font-size:13px;
                        cursor:pointer;
                    }
                }
                .goods-size-list{
                    display:flex;
                    align-items:center;
                    flex-direction:column;
                    // flex-wrap:wrap;
                    row-gap:10px;
                    width:100%;
                    .size-list-item{
                        width:100%;
                        height:46px;
                        line-height:46px;
                        border-bottom:1px dotted #d6d6d6;
                        border-radius:3px;
                        color:#1a1a1a;
                        font-size:14px;
                        user-select:none;
                        display:flex;
                        align-items:center;
                        justify-content:space-between;
                        .size-name{
                            flex:0 0 calc(100% - 60%);
                            text-align:left;
                            white-space:nowrap;
                            overflow:hidden;
                            text-overflow:ellipsis;
                            color:#333;
                            font-size:14px;
                        }
                        .price-num-box{
                            display:flex;
                            align-items:center;
                            justify-content:space-between;
                            flex:1;
                            column-gap:26px;
                            .price{
                                color:#333;
                                font-size:14px;
                                white-space:nowrap;
                                text-overflow:ellipsis;
                                overflow:hidden;
                                flex-shrink:0;
                            }
                            .stock{
                                color:#999;
                                font-size:14px;
                                white-space:nowrap;
                                text-overflow:ellipsis;
                                overflow:hidden;
                                flex-shrink:0;
                            }
                            .num{
                                display:flex;
                                align-items:center;
                                flex:1;
                                justify-content:flex-end;
                                width:100%;
                                max-width:120px;
                                .change-btn{
                                    width:28px;
                                    height:26px;
                                    display:flex;
                                    justify-content:center;
                                    align-items:center;
                                    background:#f1f1f1;
                                    cursor:pointer;
                                    color:#333;
                                    font-size:12px;
                                    &.minus{
                                        border-radius:3px 0 0 3px;
                                    }
                                    &.plus{
                                        border-radius:0 3px 3px 0;
                                    }
                                    &.disbaled-btn{
                                        cursor:not-allowed;
                                        color:#999;
                                    }
                                }
                                .num-input{
                                    flex:0 0 64px;
                                    height:26px;
                                    text-align:center;
                                    ::v-deep .ivu-input{
                                        border:none;
                                        outline:none;
                                        text-align:center;
                                        height:100%;
                                        &:focus{
                                            box-shadow:none;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .total-count-box{
                    width:100%;
                    margin-top:24px;
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    .count-num{
                        color:#666;
                        font-size:14px;
                        flex:1;
                        span{
                            color:#fe3d4d;
                        }
                    }
                    .total-price{
                        color:#666;
                        font-size:14px;
                        text-align:right;
                        span{
                            padding-left:10px;
                            color:#fe3d4d;
                            font-weight:bold;
                        }
                    }
                }
            }
            .select-count{
                color:#666666;
                font-size:14px;
                margin-top:30px;
            }
            .goods-count-box{
                display:flex;
                align-items:center;
                width:200px;
                height:52px;
                border:1px solid #d6d6d6;
                border-radius:3px;
                margin-top:20px;
                .plus, .minus{
                    width:52px;
                    height:100%;
                    text-align:center;
                    line-height:52px;
                    cursor:pointer;
                    color:#333333;
                    font-size:30px;
                    flex-shrink:0;
                    user-select:none;
                    &.disable-btn{
                        cursor:not-allowed;
                        color:#999999;
                    }
                }
                input{
                    min-width:0;
                    flex:1;
                    height:100%;
                    border:none;
                    outline:none;
                    border-left:1px solid #d6d6d6;
                    border-right:1px solid #d6d6d6;
                    text-align:center;
                    font-size:16px;
                }
            }
            .goods-detail-btn-box{
                width:100%;
                display:flex;
                column-gap:18px;
                margin-top:59px;
                margin-bottom:60px;
                .add-cart-btn, .onbuy-btn{
                    width:278px;
                    height:66px;
                    user-select:none;
                    border-radius:6px;
                    text-align:center;
                    line-height:66px;
                    color:#ffffff;
                    font-size:18px;
                    font-weight:bold;
                    cursor:pointer;
                }
                .add-cart-btn{
                    background:#333333;
                }
                .onbuy-btn{
                    background:#ff5967;
                }
            }
        }
    }
    .detail-bottom{
        // width:100%;
        max-width:1550px;
        background:#ffffff;
        border-radius:6px;
        margin-top:30px;
        // margin:30px auto 0;
        display:flex;
        justify-content:center;
        flex-wrap:wrap;
        z-index:50;
        padding:0 20px;
        .bottom-title{
            width:100%;
            text-align:center;
            margin-top:50px;
            color:#1a1a1a;
            font-size:22px;
            font-weight:bold;
        }
        .bottom-list{
            width:100%;
            display:flex;
            // justify-content:center;
            margin-top:40px;
            flex-wrap:wrap;
            gap:25px;
            padding-bottom:30px;
            .goods-item {
                width: calc(100% / 5 - 25px);
                background: #ffffff;
                display: flex;
                flex-direction: column;
                align-items: start;
                cursor:pointer;

                .goods-cover {
                    width: 100%;
                    height:430px;
                    // height:auto;
                    min-height:0;
                    // aspect-ratio:1;
                    // max-height: 430px;
                    border-radius: 6px;
                    background: #f5f5f5;
                    overflow: hidden;
                    position: relative;
                    // aspect-ratio:1;
                    display:flex;

                    img {
                        width: 100%;
                        // height: 100%;
                        height:auto;
                        display:block;
                        // min-height:330px;
                        // max-height:430px;
                        border-radius: 6px;
                        object-fit: contain;
                    }

                    .collect-btn {
                        display: none;
                    }

                    &:hover {
                        .collect-btn {
                            position: absolute;
                            right: 20px;
                            bottom: 20px;
                            background: rgba(255, 255, 255, 0.7);
                            border-radius: 16px;
                            color: #4d4d4d;
                            font-size: 12px;
                            display: flex;
                            align-items: center;
                            column-gap:4px;
                            padding: 6px 10px;
                            cursor: pointer;
                            max-height:32px;

                            .collect-icon {
                                width: 20px;
                                height: 20px;
                                max-height:20px;
                                min-height:20px;
                            }
                        }
                    }
                }

                .goods-title {
                    // margin-top:20px;
                    line-height: 35.81px;
                    color: #1a1a1a;
                    font-size: 16px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .goods-price {
                    line-height: 35.81px;
                    color: #1a1a1a;
                    font-size: 18px;
                    font-weight: bold;
                }

                .goods-author {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    .avatar {
                        width: 25px;
                        height: 25px;
                        border-radius: 50%;
                        margin-right: 9px;
                    }

                    .line {
                        margin: 0 9px;
                        font-size: 13px;
                    }

                    .nickname,
                    .count-num {
                        flex: 0 0 1;
                        color: #666666;
                        font-size: 13px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }

     @media screen and (min-width: 1280px) and (max-width: 1679px) {
        column-gap: 20px;
        padding-top: 20px;
        padding-bottom: 40px;
        .detail-top{
            .detail-left {
                flex: 0 0 650px;
                max-width:650px;

                .shop-author-info {
                    .author-left {
                        column-gap: 12px;

                        .author-avatar {
                            width: 50px;
                            height: 50px;
                        }

                        .author-info {
                            row-gap: 10px;

                            .shop-name {
                                font-size: 14px;
                            }

                            .author-info-line {
                                column-gap: 15px;

                                .desc, .count {
                                    font-size: 11px;
                                }
                            }
                        }
                    }

                    .author-right {
                        column-gap: 8px;

                        .btn-item {
                            width: 65px;
                            height: 35px;
                            line-height: 35px;
                            font-size: 13px;

                            .btn-icon {
                                width: 18px;
                                height: 18px;
                            }
                        }
                    }
                }

                .goods-img-box {
                    height: 600px;
                    column-gap: 15px;
                    margin-top: 15px;

                    .img-list {
                        width: 130px;
                        row-gap: 7px;

                        .prev, .next {
                            height: 28px;
                        }

                        .img-item {
                            height: 145px;
                        }
                    }

                    .main-img {
                        width: 505px;
                    }
                }

                .detail-box {
                    margin-top: 15px;

                    .detail-tabs {
                        padding: 25px 15px 15px 15px;
                        column-gap: 25px;

                        .tabs-item {
                            font-size: 14px;
                            &.active, &:hover{
                                &::after{
                                    bottom:-17px;
                                }
                            }
                        }
                    }

                    .detail-wrapper {
                        margin-top: 30px;
                        padding: 0 15px;

                        .part-title {
                            font-size: 18px;
                            line-height: 32px;
                        }

                        .params-table {
                            margin-top: 20px;
                            margin-bottom: 30px;

                            table {
                                td {
                                    padding: 10px 14px;
                                }

                                .label {
                                    width: 110px;
                                    padding: 10px 14px;
                                    font-size: 13px;
                                }

                                .value {
                                    font-size: 13px;
                                    padding: 10px 14px;
                                }
                            }
                        }

                        .detail-content {
                            margin-top: 25px;
                            margin-bottom: 25px;
                        }

                        .evaluate-part {
                            .top-part {
                                .top-part-title {
                                    font-size: 18px;
                                }

                                .sort-btn {
                                    width: 100px;
                                    height: 38px;
                                    font-size: 13px;
                                }
                            }

                            .evaluate-list {
                                row-gap: 25px;
                                margin-top: 30px;

                                .evaluate-item {
                                    column-gap: 10px;

                                    .user-avatar {
                                        width: 40px;
                                        height: 40px;
                                    }

                                    .item-content {
                                        .user-name {
                                            font-size: 15px;
                                        }

                                        .date-spec {
                                            font-size: 13px;
                                        }

                                        .evaluate-content {
                                            font-size: 13px;
                                            margin-top: 12px;
                                            margin-bottom: 15px;
                                        }

                                        .evaluate-img-list {
                                            gap: 10px;
                                            flex-wrap:wrap;

                                            .evaluate-img-item {
                                                width: 120px;
                                                max-height: 120px;
                                            }
                                        }

                                        .comment-like-box {
                                            column-gap: 15px;
                                            margin-top: 12px;

                                            .box-item {
                                                font-size: 11px;

                                                .item-icon {
                                                    width: 18px;
                                                    height: 18px;
                                                }
                                            }
                                        }
                                    }
                                }

                                .more-evaluate {
                                    margin-top: 5px;

                                    .more-btn {
                                        width: 140px;
                                        height: 38px;
                                        font-size: 13px;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .detail-right {
                width: 520px;
                // top: 70px;
                top:5%;
                padding: 0 30px;

                .collect-btn {
                    top: 15px;
                    right: 15px;
                    font-size: 12px;

                    img {
                        width: 18px;
                        height: 18px;
                    }
                }

                .goods-title {
                    font-size: 20px;
                    margin-top: 25px;
                }

                .goods-price {
                    column-gap: 10px;
                    margin-top: 8px;

                    .sale-price {
                        font-size: 22px;
                    }

                    .tag-price {
                        font-size: 14px;
                    }
                }

                .goods-desc {
                    font-size: 13px;
                    line-height: 25px;
                }

                .goods-feature {
                    row-gap: 4px;
                    margin-top: 15px;

                    .feature-item {
                        column-gap: 7px;
                        font-size: 12px;

                        img {
                            width: 20px;
                            height: 20px;
                        }
                    }
                }

                .goods-color-box {
                    margin-top: 30px;
                    row-gap: 15px;

                    .goods-color-select {
                        .color-label, .color-value {
                            font-size: 13px;
                        }
                    }

                    .goods-color-list {
                        column-gap: 8px;

                        .color-list-item {
                            // width: 35px;
                            // height: 35px;

                            .color-content {
                                // width: 26px;
                                // height: 26px;
                            }
                        }
                    }
                }

                .goods-size-box {
                    row-gap: 15px;
                    margin-top: 25px;

                    .goods-size-title {
                        .size-title {
                            font-size: 13px;
                        }

                        .size-table-btn {
                            font-size: 12px;
                        }
                    }

                    .goods-size-list {
                        gap: 8px;

                        .size-list-item {
                            // width: 70px;
                            height: 40px;
                            line-height: 40px;
                            font-size: 13px;
                        }
                    }
                }

                .select-count {
                    font-size: 13px;
                    margin-top: 25px;
                }

                .goods-count-box {
                    width: 170px;
                    height: 45px;
                    margin-top: 15px;

                    .plus, .minus {
                        width: 45px;
                        line-height: 45px;
                        font-size: 25px;
                    }

                    input {
                        font-size: 14px;
                    }
                }
            }
        }
    }


    @media screen and (max-width: 1279px) {
        flex-wrap: wrap;
        column-gap: 15px;
        padding-top: 15px;
        padding-bottom: 30px;

        .detail-left,
        .detail-right {
            flex: 1 1 300px;
            max-width: 600px;
            min-width: 300px;
            margin: 0 auto;
        }

        .detail-left {
            flex: 1 1 300px;
            max-width: 600px;
            min-width: 300px;

            .shop-author-info {
                .author-left {
                    column-gap: 10px;

                    .author-avatar {
                        width: 45px;
                        height: 45px;
                    }

                    .author-info {
                        row-gap: 8px;

                        .shop-name {
                            font-size: 13px;
                        }

                        .author-info-line {
                            column-gap: 12px;

                            .desc, .count {
                                font-size: 10px;
                            }
                        }
                    }
                }

                .author-right {
                    column-gap: 6px;

                    .btn-item {
                        width: 60px;
                        height: 30px;
                        line-height: 30px;
                        font-size: 12px;

                        .btn-icon {
                            width: 16px;
                            height: 16px;
                        }
                    }
                }
            }

            .goods-img-box {
                height: 500px;
                column-gap: 12px;
                margin-top: 12px;

                .img-list {
                    width: 110px;
                    row-gap: 6px;

                    .prev, .next {
                        height: 24px;
                    }

                    .img-item {
                        height: 120px;
                    }
                }

                .main-img {
                    // width: 380px;
                    flex:1;
                }
            }

            .detail-box {
                margin-top: 12px;

                .detail-tabs {
                    padding: 20px 12px 12px 12px;
                    column-gap: 20px;
                    flex-wrap: wrap;

                    .tabs-item {
                        font-size: 13px;
                        line-height: 30px;
                    }
                }

                .detail-wrapper {
                    margin-top: 25px;
                    padding: 0 12px;

                    .part-title {
                        font-size: 16px;
                        line-height: 30px;
                    }

                    .params-table {
                        margin-top: 15px;
                        margin-bottom: 25px;

                        table {
                            td {
                                padding: 8px 12px;
                            }

                            .label {
                                width: 90px;
                                padding: 8px 12px;
                                font-size: 12px;
                            }

                            .value {
                                font-size: 12px;
                                padding: 8px 12px;
                            }
                        }
                    }

                    .detail-content {
                        margin-top: 20px;
                        margin-bottom: 20px;
                    }

                    .evaluate-part {
                        .top-part {
                            .top-part-title {
                                font-size: 16px;
                            }

                            .sort-btn {
                                width: 90px;
                                height: 35px;
                                font-size: 12px;
                            }
                        }

                        .evaluate-list {
                            row-gap: 20px;
                            margin-top: 25px;

                            .evaluate-item {
                                column-gap: 8px;

                                .user-avatar {
                                    width: 35px;
                                    height: 35px;
                                }

                                .item-content {
                                    .user-name {
                                        font-size: 14px;
                                    }

                                    .date-spec {
                                        font-size: 12px;
                                    }

                                    .evaluate-content {
                                        font-size: 12px;
                                        margin-top: 10px;
                                        margin-bottom: 12px;
                                    }

                                    .evaluate-img-list {
                                        column-gap: 8px;

                                        .evaluate-img-item {
                                            width: 100px;
                                            height: 100px;
                                            position: relative;
                                            .cover-img {
                                                width: 100%;
                                                height: 100%;
                                                object-fit: cover;
                                                border-radius: 4px;
                                            }
                                        }
                                    }

                                    .comment-like-box {
                                        column-gap: 12px;
                                        margin-top: 10px;

                                        .box-item {
                                            font-size: 10px;

                                            .item-icon {
                                                width: 16px;
                                                height: 16px;
                                            }
                                        }
                                    }
                                }
                            }

                            .more-evaluate {
                                margin-top: 5px;

                                .more-btn {
                                    width: 130px;
                                    height: 35px;
                                    font-size: 12px;
                                }
                            }
                        }
                    }
                }
            }
        }

        // 右侧栏样式调整
        .detail-right {
            position: sticky;
            top: 1% !important;
            margin-top: 20px;
            padding: 0 20px;
            text-align: left;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            .goods-detail-btn-box {
                width: 100%;
                display: flex;
                justify-content: center;
                gap: 18px;
                margin-top: 59px;
                .add-cart-btn, .onbuy-btn {
                    width: 278px;
                    height: 66px;
                    user-select: none;
                    border-radius: 6px;
                    text-align: center;
                    line-height: 66px;
                    color: #ffffff;
                    font-size: 18px;
                    font-weight: bold;
                    cursor: pointer;
                }
                .add-cart-btn {
                    background: #333333;
                }
                .onbuy-btn {
                    background: #ff5967;
                }
            }

            .collect-btn {
                top: 12px;
                right: 12px;
                font-size: 11px;
                img {
                    width: 16px;
                    height: 16px;
                }
            }

            .goods-title {
                font-size: 18px;
                margin-top: 20px;
                text-align: left;
            }

            .goods-price {
                column-gap: 8px;
                margin-top: 6px;
                text-align: left;
                .sale-price {
                    font-size: 20px;
                }
                .tag-price {
                    font-size: 13px;
                }
            }

            .goods-desc {
                font-size: 12px;
                line-height: 22px;
                text-align: left;
            }

            .goods-feature {
                row-gap: 3px;
                margin-top: 12px;
                text-align: left;
                .feature-item {
                    column-gap: 6px;
                    font-size: 11px;
                    img {
                        width: 18px;
                        height: 18px;
                    }
                }
            }

            .goods-color-box,
            .goods-size-box,
            .select-count,
            .goods-count-box {
                text-align: left;
            }
        }
    }
}

//>尺码表弹窗样式
.size-table-popup{
    width:100%;
    height:100%;
    .table-pop-header{
        width:100%;
        height:80px;
        line-height:80px;
        background:#fafafa;
        border-radius:10px 10px 0 0;
        color:#1a1a1a;
        font-size:20px;
        font-weight:bold;
        border-bottom:1px solid #cccccc;
        padding-left:30px;
    }
    .size-table-body{
        padding:39px;
        table{
            width:100%;
            border-collapse:collapse;
            border:1px solid #d2d0d2;
            table-layout:fixed;
            text-align:center;
            thead{
                background:#f2f4f7;
                tr > th{
                    color:#333333;
                    font-size:14px;
                    font-weight: bold;
                }
            }
            th, td{
                border:1px solid #d2d0d2;
                height: 42px;
            }
        }
    }
}

//>购物车添加成功弹窗样式
.add-cart-success{
    width:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    padding-bottom:50px;
    .success-icon{
        width:64px;
        height:64px;
        margin-top:56px;
    }
    .success-title{
        color:#1a1a1a;
        font-size:24px;
        font-weight:bold;
        margin-top:29px;
    }
    .success-desc{
        color:#999999;
        font-size:14px;
        margin-top:17px;
    }
    .btn-box{
        margin-top:58px;
        display:flex;
        align-items:center;
        column-gap:17px;
        .continue-btn, .shop-cart-btn{
            width:180px;
            height:48px;
            border-radius:24px;
            font-size:16px;
            text-align:center;
            line-height:48px;
            cursor:pointer;
        }
        .continue-btn{
            border:1px solid #333333;
            color:#333333;
        }
        .shop-cart-btn{
            background: #333333;
            color:#ffffff;
        }
    }
}

// 视频预览弹窗样式
.video-preview-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.9);
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
    .video-preview-container {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        box-sizing: border-box;
        .video-preview-close {
            position: fixed;
            top: 20px;
            right: 20px;
            width: 40px;
            height: 40px;
            background: rgba(255, 255, 255, 0.9);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            color: #333;
            cursor: pointer;
            z-index: 1000000;
            &:hover {
                background: #fff;
            }
        }
        .video-preview {
            max-width: 90vw;
            max-height: 90vh;
            width: auto;
            height: auto;
            object-fit: contain;
            border-radius: 4px;
        }
    }
}
</style>
